import {
  CELL_RANGE_REGEX,
  CELL_REFERENCE_REGEX,
  COLUMN_RANGE_REGEX,
  ROW_RANGE_REGEX,
  SHEET_NAME_REGEX,
} from '../../constants/regex';
import { CellErrors, EntityIdToName } from '../../types';
import { extractSheetAndAddress } from './address';
import { ParseSingleAddress, parseSingleAddress } from './singleAddress';

export type ExtractedAddress = {
  address: string;
  sheetId: string;
};
export const extractFormulaAddresses = (
  formula: string,
  defaultSheetId: string
): ExtractedAddress[] => {
  const tokens = parseFormulaAddresses(formula);

  return tokens.map((token) => {
    const { sheet, address } = extractSheetAndAddress(token, defaultSheetId);
    return {
      sheetId: sheet,
      address,
    };
  });
};

export const replaceOldAddressInFormula = (
  cellSheetId: string,
  oldAddress: string,
  formula: string,
  newAddress?: string | undefined // = '#REF'
) => {
  const tokens = parseFormulaAddresses(formula);

  for (const token of tokens) {
    const { sheet: id, address } = extractSheetAndAddress(token, cellSheetId);

    if (id === cellSheetId) {
      const relativeAddress = address.replaceAll('$', '');

      if (relativeAddress === oldAddress) {
        let newToken = token;
        // let newToken = token.replace(address, newAddress);

        if (newAddress) newToken = token.replace(address, newAddress);
        else newToken = token.replace(token, CellErrors.REF);

        formula = formula.replace(token, newToken);
      }
    }
  }

  return formula;
};

// export const replaceSheetNamesWithId = (
//   formula: string,
//   sheetsIdToName: EntityIdToName
// ) => {
//   let error = '';
//   const tokens = parseFormulaAddresses(formula);
//   for (const token of tokens) {
//     if (token.includes('!')) {
//       const [refSheetId, adr] = token.split('!');

//       const sheetName =
//         refSheetId.startsWith("'") && refSheetId.endsWith("'")
//           ? refSheetId.substring(1, refSheetId.length - 1)
//           : refSheetId;

//       const sheetId = getSheetIdFromSheetName(sheetsIdToName, sheetName);
//       if (sheetId) {
//         formula = formula.replaceAll(token, `'${sheetId}'!${adr}`);
//       } else {
//         error += `'${sheetName}' `;
//       }
//       sheetName.toLowerCase();
//     }
//   }

//   return {
//     input: formula,
//     error: error.length ? `Unresolved sheet name ${error}` : undefined,
//   };
// };

export const replaceSheetIdWithName = (
  formula: string,
  sheetsIdToName: EntityIdToName
) => {
  const tokens = parseFormulaAddresses(formula);
  for (const token of tokens) {
    if (token.includes('!')) {
      const [refSheetId, adr] = token.split('!');

      const sheetId =
        refSheetId.startsWith("'") && refSheetId.endsWith("'")
          ? refSheetId.substring(1, refSheetId.length - 1)
          : refSheetId;

      // let sheetName = getSheetNameFromSheetId(sheetsIdToName, sheetId);

      const sheetName = sheetsIdToName[sheetId];

      if (sheetName) {
        formula = formula.replaceAll(`'${sheetId}'`, sheetName);
        formula = formula.replaceAll(sheetId, sheetName);
      }
    }
  }

  return formula;
};

// export const getSheetIdFromSheetName = (
//   sheetsIdToName: EntityIdToName,
//   sheetName: string
// ) =>
//   Object.keys(sheetsIdToName).find(
//     (key) => sheetsIdToName[key].toLowerCase() === sheetName.toLowerCase()
//   );

export const parseFormulaAddresses = (formula: string) => {
  // const SHEET_NAME = new RegExp(SHEET_NAME_REGEX, 'g');
  const CELL_REFERENCE = new RegExp(CELL_REFERENCE_REGEX, 'g');
  const COLUMN_RANGE = new RegExp(COLUMN_RANGE_REGEX, 'g');
  const ROW_RANGE = new RegExp(ROW_RANGE_REGEX, 'g');
  const CELL_RANGE = new RegExp(CELL_RANGE_REGEX, 'g');
  //   const FUNCTION_REGEX = /([A-Z]+)\(([^)]+)\)/g; // Example: SUM(A:A)

  const tokens: string[] = [];

  let match;
  let remainingFormula = formula;

  // Extract sheet names
  //   while ((match = SHEET_NAME_REGEX.exec(remainingFormula)) !== null) {
  //     tokens.push(match[0]);
  //   }

  // Extract cell references
  //   remainingFormula = remainingFormula.replace(SHEET_NAME_REGEX, '');
  while ((match = CELL_RANGE.exec(remainingFormula)) !== null) {
    tokens.push(match[0]);
  }

  remainingFormula = remainingFormula.replace(CELL_RANGE, '');
  while ((match = CELL_REFERENCE.exec(remainingFormula)) !== null) {
    tokens.push(match[0]);
  }

  // Extract column ranges
  remainingFormula = remainingFormula.replace(CELL_REFERENCE, '');
  while ((match = COLUMN_RANGE.exec(remainingFormula)) !== null) {
    tokens.push(match[0]);
  }

  // Extract row ranges
  remainingFormula = remainingFormula.replace(COLUMN_RANGE, '');
  while ((match = ROW_RANGE.exec(remainingFormula)) !== null) {
    tokens.push(match[0]);
  }

  // Extract functions
  //   remainingFormula = remainingFormula.replace(ROW_RANGE, '');
  //   while ((match = FUNCTION_REGEX.exec(remainingFormula)) !== null) {
  //     tokens.push(match[0]);
  //   }

  // Remaining formula can contain operators or invalid characters
  // Add code here to handle operators, literals, or raise errors for invalid characters.

  return tokens;
};
